import React from 'react';
import { UnstyledButton } from '@shopify/polaris';
import { classNames, variationName } from '@shopify/css-utilities';
import styles from './FormattingList.scss.mjs';
import FormattingCheck from './icons/formatting-check.svg.mjs';

function FormattingList({
  selected,
  options,
  onSelect
}) {
  const listItems = options.map(option => {
    const itemSelected = selected === option.key;
    const buttonClassName = classNames(styles.OptionButton, itemSelected && styles['OptionButton-selected'], styles[variationName('element', option.key)]);
    const checkMark = itemSelected && /*#__PURE__*/React.createElement("div", {
      className: styles.SelectedCheck
    }, /*#__PURE__*/React.createElement(FormattingCheck, null));
    return /*#__PURE__*/React.createElement("li", {
      className: styles.Option,
      key: option.key
    }, /*#__PURE__*/React.createElement(UnstyledButton, {
      className: buttonClassName,
      onClick: () => onSelect(option.key),
      pressed: itemSelected
    }, checkMark, option.label));
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: styles.FormattingList
  }, listItems);
}

export { FormattingList };
